import { makeStyles, shorthands } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

const DIALOG_MAX_WIDTH = "650px";

export const useStyles = makeStyles({
  dialogSurface: {
    maxWidth: DIALOG_MAX_WIDTH,
    maxHeight: "90vh",
  },
  dialogContentOverride: {
    maxHeight: "calc(80vh - 120px)",
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[4],
  },
  fieldLabelOverride: {
    fontWeight: designTokens.fontWeight.semibold,
  },
  fieldValueColor: {
    color: designTokens.neutral[900],
  },
  fieldValuePreWrap: {
    whiteSpace: "pre-wrap",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    paddingTop: designTokens.spacing[4],
  },
  assistanceSelect: {
    width: "100%",
  },
  responseContainer: {
    backgroundColor: designTokens.neutral[100],
    ...shorthands.borderRadius(designTokens.borderRadius.md),
    ...shorthands.padding(designTokens.spacing[3]),
    fontSize: designTokens.fontSize.sm,
    "& h1, & h2, & h3": {
      fontSize: designTokens.fontSize.base,
      fontWeight: designTokens.fontWeight.bold,
      ...shorthands.margin("0"),
    },
    "& h4, & h5, & h6": {
      fontSize: designTokens.fontSize.sm,
      fontWeight: designTokens.fontWeight.semibold,
      ...shorthands.margin("0"),
    },
  },
});
